// ============================================================================
// PRESET LAYOUTS - Default layout configurations for the second screen
// These serve as starting points; users can customize via the layout editor
// ============================================================================

import type { SecondScreenLayout } from '../../types/second-screen.types';
import { WIDGET_IDS } from './widgets/widgetRegistry';

let instanceCounter = 0;
function inst(widgetId: string, x: number, y: number, w: number, h: number, config: Record<string, any> = {}) {
  return {
    instanceId: `preset-${widgetId}-${++instanceCounter}`,
    widgetId,
    config,
    x, y, w, h,
  };
}

export const PRESET_LAYOUTS: SecondScreenLayout[] = [
  {
    id: 'mission-control',
    name: 'Mission Control',

    cols: 12,
    widgets: [
      inst(WIDGET_IDS.AVATAR_RING, 0, 0, 9, 2),
      inst(WIDGET_IDS.PULSE_INDICATOR, 9, 0, 3, 2),
      inst(WIDGET_IDS.STATS_BAR, 0, 2, 6, 2),
      inst(WIDGET_IDS.CURRENT_PHASE, 6, 2, 3, 2),
      inst(WIDGET_IDS.TIMER, 9, 2, 3, 2),
      inst(WIDGET_IDS.FOCUS_VIEW, 0, 4, 12, 4, { subView: 'transcript' }),
    ],
  },
  {
    id: 'avatar-focus',
    name: 'Avatar Focus',

    cols: 12,
    widgets: [
      inst(WIDGET_IDS.AVATAR_RING, 0, 0, 12, 3),
      inst(WIDGET_IDS.AVATAR_SCOREBOARD, 0, 3, 4, 4),
      inst(WIDGET_IDS.WHOS_NEXT, 4, 3, 4, 4),
      inst(WIDGET_IDS.ENGAGEMENT_GAUGE, 8, 3, 4, 4),
      inst(WIDGET_IDS.TRANSCRIPT_CRAWL, 0, 7, 12, 1),
    ],
  },
  {
    id: 'presentation',
    name: 'Presentation',

    cols: 12,
    widgets: [
      inst(WIDGET_IDS.CURRENT_PHASE, 0, 0, 4, 2),
      inst(WIDGET_IDS.PROMPT_CARD, 4, 0, 8, 4),
      inst(WIDGET_IDS.SESSION_JOURNEY_MAP, 0, 2, 4, 2),
      inst(WIDGET_IDS.WORD_CLOUD, 0, 4, 6, 4),
      inst(WIDGET_IDS.STATS_BAR, 6, 4, 6, 2),
      inst(WIDGET_IDS.TRANSCRIPT_CRAWL, 6, 6, 6, 2),
    ],
  },
  {
    id: 'data-deep-dive',
    name: 'Data Deep Dive',

    cols: 12,
    widgets: [
      inst(WIDGET_IDS.STATS_BAR, 0, 0, 12, 2),
      inst(WIDGET_IDS.ENGAGEMENT_HEATMAP, 0, 2, 6, 3),
      inst(WIDGET_IDS.AI_INSIGHTS_FEED, 6, 2, 6, 3),
      inst(WIDGET_IDS.ASSUMPTION_WALL, 0, 5, 6, 3),
      inst(WIDGET_IDS.DECISION_LOG, 6, 5, 6, 3),
    ],
  },
  {
    id: 'facilitator',
    name: 'Facilitator',

    cols: 12,
    widgets: [
      inst(WIDGET_IDS.STATS_BAR, 0, 0, 12, 2),
      inst(WIDGET_IDS.ENGAGEMENT_GAUGE, 0, 2, 3, 3),
      inst(WIDGET_IDS.TASK_CONTENT, 0, 5, 3, 3),
      inst(WIDGET_IDS.FOCUS_VIEW, 3, 2, 6, 6, { subView: 'transcript' }),
      inst(WIDGET_IDS.DEVICE_STATUS, 9, 2, 3, 3),
      inst(WIDGET_IDS.PULSE_INDICATOR, 9, 5, 3, 3),
    ],
  },
  {
    id: 'inspiration-wall',
    name: 'Inspiration Wall',

    cols: 12,
    widgets: [
      inst(WIDGET_IDS.INSPIRATION_WALL, 0, 0, 9, 8, { rotationInterval: '5', maxVisibleCards: '8' }),
      inst(WIDGET_IDS.CURRENT_PHASE, 9, 0, 3, 1),
      inst(WIDGET_IDS.WORD_CLOUD, 9, 1, 3, 7),
    ],
  },
  {
    id: 'knowledge-graph',
    name: 'Knowledge Graph',

    cols: 12,
    widgets: [
      inst(WIDGET_IDS.PROJECT_GRAPH, 0, 0, 9, 8),
      inst(WIDGET_IDS.CURRENT_PHASE, 9, 0, 3, 2),
      inst(WIDGET_IDS.STATS_BAR, 9, 2, 3, 2),
      inst(WIDGET_IDS.WORD_CLOUD, 9, 4, 3, 4),
    ],
  },
  {
    id: 'task-outputs',
    name: 'Task Outputs',

    cols: 12,
    widgets: [
      inst(WIDGET_IDS.TASK_CONTENT, 0, 0, 12, 8),
    ],
  },
  {
    id: 'welcome-left',
    name: 'Welcome Left',

    cols: 12,
    widgets: [
      inst(WIDGET_IDS.CLOCK, 0, 0, 3, 3),
      inst(WIDGET_IDS.WELCOME_HEADER, 3, 0, 9, 3),
      inst(WIDGET_IDS.AGENDA, 0, 3, 3, 5),
      inst(WIDGET_IDS.INSPIRATION_WALL, 3, 3, 9, 5, { rotationInterval: '5', maxVisibleCards: '6' }),
    ],
  },
  {
    id: 'welcome-right',
    name: 'Welcome Right',

    cols: 12,
    widgets: [
      inst(WIDGET_IDS.ATTENDEE_LIST, 0, 0, 9, 3),
      inst(WIDGET_IDS.PARTICIPANT_PANEL, 9, 0, 3, 8),
      inst(WIDGET_IDS.PROJECT_GRAPH, 0, 3, 9, 5),
    ],
  },
  {
    id: 'cinematic-live',
    name: 'Cinematic Live',

    cols: 12,
    widgets: [
      inst(WIDGET_IDS.AMBIENT_BACKGROUND, 0, 0, 12, 8, { intensity: 'high' }),
    ],
  },
  {
    id: 'requirements-mirror',
    name: 'Requirements Mirror',

    cols: 12,
    widgets: [
      inst(WIDGET_IDS.REQUIREMENTS_MIRROR, 0, 0, 12, 8),
    ],
  },
];
